import React from 'react';
import { ArcButtonProps, ArcButtonVariantProps } from './types';
import { Button } from '@mui/material';
import ArcText from '@src/core/ui/arc-text';
import ArcCircularProgress from '@src/core/ui/arc-circular-progress';

const ArcButton: React.FC<ArcButtonProps> & ArcButtonVariantProps = (props) => {
  const { children, sx, isLoading, disabled, startIcon, ...rest } = props;

  return (
    <Button 
      {...rest} 
      sx={sx}
      disabled={isLoading || disabled}
      startIcon={isLoading ? <ArcCircularProgress size={18} sx={{ color: 'action.disabled' }} /> : startIcon}> 
      {children} 
    </Button>
  );
}; 

ArcButton.ghost = ({ children, ...rest }) => (
  <ArcButton variant='contained' color='ghost' {...rest}>
    <ArcText.button disabled={rest.isLoading || rest.disabled} color='text.primary'>
      {children}
    </ArcText.button>
  </ArcButton>
);

ArcButton.brand = ({ children, ...rest }) => {
  return (
    <ArcButton variant='contained' color='brand' {...rest}>
      <ArcText.button disabled={rest.isLoading || rest.disabled} color='text.night'>
        {children}
      </ArcText.button>
    </ArcButton>
  );
};

ArcButton.tertiary = ({ children, ...rest }) => (
  <ArcButton variant='text' color='brand' {...rest}>
    <ArcText.button disabled={rest.isLoading || rest.disabled} color='brand.main'>
      {children}
    </ArcText.button>
  </ArcButton>
);

ArcButton.outlined = ({ children, ...rest }) => (
  <ArcButton variant='outlined' color='ghost' {...rest} sx={{ borderColor: 'divider', ...rest.sx }}>
    <ArcText.button disabled={rest.isLoading || rest.disabled} color='text.primary'>
      {children}
    </ArcText.button>
  </ArcButton>
);

export default ArcButton;